import { Link, useNavigate } from "react-router-dom";
import { FaShoppingBasket, FaHeart } from "react-icons/fa";
import { FiUserPlus, FiLogIn } from "react-icons/fi";
import { useEffect, useState } from "react";
import CartDrawer from "./CartDrawer"; // adjust path if needed
import WishlistDrawer from "./WishlistDrawer";

const NormalHeader = () => {
  const [cartCount, setCartCount] = useState(0);
  const [wishlistCount, setWishlistCount] = useState(0);
  const [showCart, setShowCart] = useState(false);
  const [showWishlist, setShowWishlist] = useState(false);
  const navigate = useNavigate();

  // Common helper to read storage safely
  const readStorageArray = (key) => {
    try {
      const raw = sessionStorage.getItem(key) ?? localStorage.getItem(key);
      const arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch {
      return [];
    }
  };

  // Cart count sync
  const updateCartCount = () => {
    const arr = readStorageArray("cart");
    setCartCount(arr.length);
  };

  // Wishlist count sync
  const updateWishlistCount = () => {
    const arr = readStorageArray("wishlist");
    setWishlistCount(arr.length);
  };

  useEffect(() => {
    updateCartCount();
    updateWishlistCount();

    // optional: listen to storage changes across tabs/components
    const onStorage = (e) => {
      if (e.key === "cart") updateCartCount();
      if (e.key === "wishlist") updateWishlistCount();
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  // Navigation item definitions
  const navItems = [
    {
      key: "register",
      label: "Register",
      icon: <FiUserPlus />,
      link: "/user/customer/register",
    },
    { key: "login", label: "Login", icon: <FiLogIn />, link: "/user/login" },
    {
      key: "wishlist",
      label: "My Wishlist",
      icon: <FaHeart />,
      badge: true,
    },
    {
      key: "cart",
      label: "My Cart",
      icon: <FaShoppingBasket />,
      badge: true,
    },
  ];

  // RENDER
  return (
    <>
      <ul className="navbar-nav ms-auto mb-2 mb-lg-0 me-4 align-items-center gap-3 header-icon-menu">
        {navItems.map((item) => (
          <li key={item.key} className="nav-item position-relative text-center">
            {/* CART ICON HANDLED SEPARATELY TO OPEN DRAWER */}
            {item.key === "cart" ? (
              <button
                type="button"
                className="nav-link d-inline-flex align-items-center justify-content-center icon-only-link btn btn-link"
                aria-label={item.label}
                onClick={() => setShowCart(true)}
              >
                <div className="icon-fixed-size" aria-hidden>
                  {item.icon}
                  {item.badge && cartCount > 0 && (
                    <span className="cart-badge" aria-hidden>
                      {cartCount}
                    </span>
                  )}
                </div>
                <div className="icon-tooltip" role="tooltip">
                  {item.label}
                </div>
              </button>
            ) : item.key === "wishlist" ? (
              <button
                type="button"
                className="nav-link d-inline-flex align-items-center justify-content-center icon-only-link btn btn-link"
                aria-label="My Wishlist"
                onClick={() => setShowWishlist(true)}
              >
                <div className="icon-fixed-size position-relative" aria-hidden>
                  <FaHeart size={20} color="#222" />
                  {wishlistCount > 0 && (
                    <span className="wishlist-only-badge">{wishlistCount}</span>
                  )}
                </div>
                <div className="icon-tooltip">My Wishlist</div>
              </button>
            ) : (
              <Link
                to={item.link}
                className="nav-link d-inline-flex align-items-center justify-content-center icon-only-link"
                aria-label={item.label}
              >
                <div className="icon-fixed-size" aria-hidden>
                  {item.icon}
                </div>
                <div className="icon-tooltip" role="tooltip">
                  {item.label}
                </div>
              </Link>
            )}
          </li>
        ))}
      </ul>

      {/* Cart Drawer (right slide panel) */}
      <CartDrawer
        show={showCart}
        onClose={() => setShowCart(false)}
        onCartChange={(newCount) => setCartCount(newCount)}
      />

      <WishlistDrawer
        show={showWishlist}
        onClose={() => setShowWishlist(false)}
        onWishlistChange={(newCount) => setWishlistCount(newCount)}
      />
    </>
  );
};

export default NormalHeader;
